export function convertMuiFilterForParkerTable(operator: string, val: string | null) {
	const operatorMap = {
		// Numeric operators
		'=': 'EQUALS',
		'!=': 'NOT_EQUALS',
		'>': 'GREATER_THAN',
		'>=': 'GT_EQUALS',
		'<': 'LESS_THAN',
		'<=': 'LT_EQUALS',

		// // String operators
		equals: 'EQUALS',
		contains: 'LIKE',
		startsWith: 'LIKE',
		endsWith: 'LIKE',

		// // Date operators
		is: 'EQUALS',
		not: 'NOT_EQUALS',
		after: 'GREATER_THAN',
		onOrAfter: 'GT_EQUALS',
		before: 'LESS_THAN',
		onOrBefore: 'LT_EQUALS',

		// // Multi-type operators
		isEmpty: 'EQUALS',
		isNotEmpty: 'NOT_EQUALS',
		isAnyOf: 'IN',
	};

	const op = operatorMap[operator as keyof typeof operatorMap];
	if (!op) throw new Error(`Invalid operator ${operator}`);

	let value = val;
	switch (operator) {
		case 'contains':
			value = `%${val}%`;
			break;
		case 'startsWith':
			value = `${val}%`;
			break;
		case 'endsWith':
			value = `%${val}`;
			break;
		case 'isEmpty':
		case 'isNotEmpty':
			value = null;
			break;
		default:
	}

	return { op, value };
}

interface LabelOptions {
	label: string;
	value: string;
}
export function findLabelFromValueAndOptions(target: string | null, options: LabelOptions[]) {
	if (!options) return null;

	const index = options.map(({ value }) => value).indexOf(target as string);
	if (index !== -1) {
		return options[index].label;
	}
	return null;
}

export function convertMuiFilterForV2ApiWithoutValue(operator: string): string {
	const operatorMap = {
		// Numeric operators
		'=': 'equals',
		'!=': 'not',
		'>': 'gt',
		'>=': 'gte',
		'<': 'lt',
		'<=': 'lte',

		// Date operators
		is: 'equals',
		after: 'gt',
		onOrAfter: 'gte',
		before: 'lt',
		onOrBefore: 'lte',

		// Multi-type operators
		isEmpty: 'equals',
		isNotEmpty: 'not',
		isAnyOf: 'in',
	};

	const op = operatorMap[operator];
	if (!op) return operator;
	return op;
}

export function convertMuiFilterForV2Api(operator: string, val: string): { op: string; value: string } {
	const operatorMap = {
		// Numeric operators
		'=': 'equals',
		'!=': 'not',
		'>': 'gt',
		'>=': 'gte',
		'<': 'lt',
		'<=': 'lte',

		// Date operators
		is: 'equals',
		after: 'gt',
		onOrAfter: 'gte',
		before: 'lt',
		onOrBefore: 'lte',

		// Multi-type operators
		isEmpty: 'equals',
		isNotEmpty: 'not',
		isAnyOf: 'in',
	};

	let op = operatorMap[operator];

	if (!op) op = operator;

	let value = val;
	switch (operator) {
		case 'contains':
			value = `%${val}%`;
			break;
		case 'startsWith':
			value = `${val}%`;
			break;
		case 'endsWith':
			value = `%${val}`;
			break;
		case 'isEmpty':
		case 'isNotEmpty':
			value = null;
			break;
		default:
	}
	return { op, value };
}

// Converts MUI GridFilterModel values to the GraphQL values expected by the monthly API
export function convertMuiFilterForApi(operator: string, val: string) {
	const operatorMap = {
		// Numeric operators
		'=': 'EQ',
		'!=': 'NE',
		'>': 'GT',
		'>=': 'GTE',
		'<': 'LT',
		'<=': 'LTE',

		// String operators
		equals: 'EQ',
		contains: 'LIKE',
		startsWith: 'LIKE',
		endsWith: 'LIKE',

		// Date operators
		is: 'EQ',
		not: 'NE',
		after: 'GT',
		onOrAfter: 'GTE',
		before: 'LT',
		onOrBefore: 'LTE',

		// Multi-type operators
		isEmpty: 'EQ',
		isNotEmpty: 'NE',
		isAnyOf: 'IN',
	};

	const op = operatorMap[operator];
	if (!op) throw new Error(`Invalid operator ${operator}`);

	let value = val;
	switch (operator) {
		case 'contains':
			value = `%${val}%`;
			break;
		case 'startsWith':
			value = `${val}%`;
			break;
		case 'endsWith':
			value = `%${val}`;
			break;
		case 'isEmpty':
		case 'isNotEmpty':
			value = null;
			break;
		default:
	}

	return { op, value };
}
